export const founder = {
  name: 'Prashanth Sekhar',
  role: 'Founder & Principal Adviser',
  location: 'Bengaluru & Chennai',
  credential: 'SEBI Registered Investment Adviser · 15+ years',
  portrait: 'https://cdn.magicpatterns.com/uploads/dRF3u4Vm2WeuQbqZ7xGS7h/profile_picture.png',
  bio: [
    'Prashanth has spent more than fifteen years across both public and private markets — running listed-equity and fixed income mandates, and evaluating unlisted and private-market opportunities on their own terms rather than through a distributor’s brochure.',
    'He is a SEBI Registered Investment Adviser, which means he is paid by the families he advises and by nobody else. There is no commission, no revenue share, and no product manufacturer with a claim on his recommendation.',
    'A Chennai native, he founded MeraBucket in Bengaluru in 2026 and opened its first branch in Chennai the same year — built on a simple observation: the quality of advice a family receives in India still depends far too much on the pin code it happens to live in.',
  ],
}

export interface DeskFunction {
  title: string
  detail: string
}

/** What the central desk owns today. Deliberately stated as functions, not headcount. */
export const deskFunctions: DeskFunction[] = [
  {
    title: 'Research & asset allocation',
    detail:
      'The house view, the model portfolios across risk mandates, and the rebalancing discipline every client portfolio is held to.',
  },
  {
    title: 'Product due diligence',
    detail:
      'The approved shelf. Funds, PMS, AIF, bonds and private-market opportunities are only recommended after they clear written diligence.',
  },
  {
    title: 'Tax & structuring',
    detail:
      'Holding structure and post-tax review, run alongside the family’s existing chartered accountant rather than in place of them.',
  },
  {
    title: 'Estate & succession',
    detail:
      'Wills, private trusts and nomination hygiene, coordinated with external legal counsel who draft and file.',
  },
  {
    title: 'Reporting & reconciliation',
    detail:
      'One consolidated statement across every family member and entity, reported post-tax with our fee shown in rupees.',
  },
  {
    title: 'Specialist panel',
    detail:
      'Named chartered accountants, lawyers and insurance analysts we retain on call, so the family does not have to assemble them.',
  },
]
